import { render, staticRenderFns } from "./CMCurssusenPage.vue?vue&type=template&id=182619fa&lang=pug"
import script from "./CMCurssusenPage.vue?vue&type=script&lang=js"
export * from "./CMCurssusenPage.vue?vue&type=script&lang=js"
import style0 from "./CMCurssusenPage.vue?vue&type=style&index=0&id=182619fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports